import { Button, Card, Tabs } from 'antd';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MessageInfo from '../components/MessageInfo';
import '../../../../styles/pages/seller/_sellers.scss';
import DetailsPro from '@root/modules/Forwarder/Detail/components/DetailsPro';
import ShipmentMethodCanEdit from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethodCanEdit';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import CheckPoint from '@root/modules/Warehouse/Shared/Common/CheckPoint';
import forwardingService from '../../Message/services/forwarding';
const MessageDetail = () => {
  const [quotation, setQuotation] = useState<any>();
  const [seller, setSeller] = useState<any>();
  console.log(quotation, 'HI');
  const [tab, setTab] = useState('');
  console.log(tab);
  const breadcrumbList = [
    {
      tittle: '국제운송 문의',
      url: ''
    },
    {
      tittle: tab === '2' || !quotation ? '메세지' : '견적 상세',
      url: ''
    }
  ];

  const { id } = useParams<{ id: string }>();
  const fetchData = async () => {
    const res = await forwardingService.getMessageDetail(Number(id));
    setQuotation(res?.quotation);
    setSeller(res?.seller);
  };
  useEffect(() => {
    fetchData();
  }, []);

  console.log(quotation, 'quotation');

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div className="busk-tabs">
          {quotation ? (
            <Tabs defaultActiveKey="1" onChange={setTab}>
              <Tabs.TabPane tab="견적 상세" key={'1'}>
                <div className="shipping-detail">
                  <div className="admin-container">
                    <Card
                      bordered={false}
                      className="admin-card btnImport"
                      style={{
                        minHeight: '80vh',
                        background: 'none'
                      }}
                    >
                      <div
                        className=""
                        style={{
                          backgroundColor: 'white',
                          padding: '20px 10px',
                          borderRadius: '6px'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',

                            background: 'white',
                            borderBottom: '1px solid #d9d9d9'
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '0 10px 30px',
                              background: 'white'
                            }}
                          >
                            <p
                              style={{
                                marginBottom: '0px',
                                fontWeight: 'bold',
                                fontSize: '15px'
                              }}
                            >
                              {seller?.companyName}
                            </p>
                            <p
                              style={{
                                marginBottom: '0px',
                                marginLeft: '10px',
                                color: '#747274'
                              }}
                            >
                              {seller?.email}
                            </p>
                          </div>
                          <div className="header-detail" style={{ padding: 0 }}>
                            <Button>{quotation?.progressStatus}</Button>
                          </div>
                        </div>

                        <DetailsPro {...quotation?.products?.[0]} />

                        <div
                          style={{
                            display: 'flex',
                            marginTop: '15px',
                            gap: '10px'
                          }}
                        >
                          <ShipmentMethodCanEdit
                            shipmentMethod={quotation?.shipmentMethod}
                          />
                          <ShippingPlant
                            shippingPlanEta={quotation?.shippingPlanEta}
                            shippingPlanEtd={quotation?.shippingPlanEtd}
                          />
                          <CheckPoint
                            data={{ checkPoint: quotation?.comment }}
                          />
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane key="2" tab="메세지">
                <MessageInfo />
              </Tabs.TabPane>
            </Tabs>
          ) : (
            <MessageInfo />
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageDetail;
